// @ts-nocheck
import { Controller } from '@hotwired/stimulus';
import { AGENT_SEARCH_PATH } from '@/constant/routers/path';

export default class extends Controller {
  static targets = [
    'form',
    'modal',
    'items',
    'prefectures',
    'cities',
    'prefectureChildren',
    'itemOccupationChecked',
    'itemPrefectureChecked',
    'jobCount',
  ];

  connect() {
    this.setupAccordionListeners();
  }

  setupAccordionListeners() {
    document.querySelectorAll('.accordion-button').forEach(button => {
      button.addEventListener('show.bs.collapse', event => {
        const parentCheckbox = event.target
          .closest('.accordion-item')
          .querySelector('input[type="checkbox"]');
        if (parentCheckbox && parentCheckbox.checked) {
          event.preventDefault();
        }
      });
    });
  }

  // Modal関連のメソッド
  onOpenModal() {
    this.removeModalBackdrop();
  }

  onCloseModal() {
    this.removeModalBackdrop();
    document.body.style.overflow = '';
  }

  onCloseDropdown() {
    document.querySelector('.dropdown-search-condition').classList.remove('show');
  }

  // チェックボックス関連のメソッド
  toggleChildCheckboxes(event) {
    const { parentId } = event.target.dataset;
    const isChecked = event.target.checked;

    const childCheckboxes = document.querySelectorAll(
      `input[type="checkbox"][data-parent-id="${parentId}"]`
    );
    childCheckboxes.forEach(checkbox => (checkbox.checked = isChecked));

    // 子チェックボックスがすべて外れた場合、親チェックボックスも外す
    if (!isChecked) {
      const allChildrenUnchecked = Array.from(childCheckboxes).every(checkbox => !checkbox.checked);
      if (allChildrenUnchecked) {
        event.target.checked = false;
      }
    }
  }

  checkParentCheckbox(event) {
    const { parentId } = event.target.dataset;
    const parentCheckbox = document.querySelector(
      `input[type="checkbox"][data-parent-id="${parentId}"]`
    );
    const childCheckboxesArray = Array.from(
      document.querySelectorAll(`input[type="checkbox"][data-parent-id="${parentId}"]`)
    ).filter(input => input.value !== parentId);

    // 子チェックボックスがすべて外れた場合、親チェックボックスも外す
    const allChildrenUnchecked = childCheckboxesArray.every(checkbox => !checkbox.checked);
    if (allChildrenUnchecked) {
      parentCheckbox.checked = false;
    } else {
      parentCheckbox.checked = true;
    }
  }

  onDisableCity(event) {
    const cityItems = document.getElementsByClassName(`parent_${event.target.id}`);
    Array.from(cityItems).forEach(item => {
      item.disabled = !event.target.checked;
    });
  }

  // 保存関連のメソッド
  onSaveOccupation(event) {
    const contentHTML = this.generateOccupationContent(event);
    this.itemOccupationCheckedTarget.innerHTML = contentHTML;
  }

  onSavePrefecture(event) {
    const contentHTML = this.generatePrefectureContent(event);
    this.itemPrefectureCheckedTarget.innerHTML = contentHTML;
  }

  onSaveItem(event, item) {
    if (!item.querySelector('input').checked) return '';

    const label = item.querySelector('.form-check-label').textContent;
    const id = item.querySelector('input').value;
    return this.createBadgeElement(label, event.params.attribute, id);
  }

  // 削除関連のメソッド
  onRemove(event) {
    event.target.parentNode.remove();
    document.getElementById(event.params.checkbox).checked = false;
  }

  onRemovePrefecture() {
    event.target.parentNode.remove();
    const checkbox = document.getElementById(event.params.checkbox);
    checkbox.checked = false;

    document
      .querySelectorAll(`.parent_${event.params.checkbox}:checked`)
      .forEach(item => (item.checked = false));
  }

  onSearchCondition(event) {
    event.preventDefault();
    const form = new FormData(this.formTarget);
    const formData = new FormData();
    this._getFormDataSearchCondition(form, formData);

    const queryString = new URLSearchParams(formData).toString();
    const delimiter = AGENT_SEARCH_PATH.includes('?') ? '&' : '?';
    const url = queryString ? AGENT_SEARCH_PATH + delimiter + queryString : AGENT_SEARCH_PATH;
    window.location.href = url;
  }

  // ユーティリティメソッド
  removeModalBackdrop() {
    document.querySelectorAll('.modal-backdrop').forEach(element => {
      element.classList.remove('modal-backdrop', 'fade', 'show');
    });
  }

  createBadgeElement(label, attribute, id) {
    return `<span class='badge bg-light border text-dark fw-normal size-12 lh-12'> ${label}
      <button class='btn-close btn-close-primary size-10 ms-2 color-primary' type='button'
      data-action='click->dropdown-search-condition#onRemove'
      data-dropdown-search-condition-checkbox-param='${attribute}_${id}'></button></span>`;
  }

  generateOccupationContent(event) {
    let contentHTML = '';

    this.itemsTargets.forEach(item => {
      if (item.querySelector('input').checked) {
        contentHTML += this.onSaveItem(event, item);
      }
    });

    return contentHTML;
  }

  generatePrefectureContent(event) {
    let contentHTML = '';

    this.prefecturesTargets.forEach(item => {
      if (item.querySelector('input').checked) {
        const prefectureId = item.querySelector('input').value;
        const prefectureLabel = item.querySelector(
          `.form-check-label[for='prefecture_id_${prefectureId}']`
        ).textContent;
        let prefectureContent = prefectureLabel;

        item.querySelectorAll(`input[name='prefecture_${prefectureId}_city']`).forEach(city => {
          if (city.checked) {
            const cityLabel = item.querySelector(
              `.form-check-label[for='prefecture_id_${city.value}']`
            ).textContent;
            prefectureContent += `/${cityLabel}`;
          }
        });

        contentHTML += this.createBadgeElement(
          prefectureContent,
          event.params.attribute,
          prefectureId
        );
      }
    });

    return contentHTML;
  }

  getFormDataForSearch() {
    const form = new FormData(this.formTarget);
    const formData = new FormData();

    const occupations = this.getOccupationIds(form);
    const prefectures = this.getPrefectureIds(form);
    const { min_income, max_income } = this.getAnnualIncome(form);

    occupations.forEach(occupation => formData.append('job_types[]', occupation));
    prefectures.forEach(prefecture => formData.append('prefectures[]', prefecture));

    if (min_income) formData.append('min_annual_income', min_income);
    if (max_income) formData.append('max_annual_income', max_income);

    return formData;
  }

  // フォームデータ取得メソッド
  getOccupationIds(form) {
    return form.getAll('occupation_ids');
  }

  getPrefectureIds(form) {
    return form.getAll('prefecture_ids');
  }

  getCityIds(form, prefectures) {
    return prefectures.flatMap(prefecture => form.getAll(`prefecture_${prefecture}_city`));
  }

  getAnnualIncome(form) {
    return {
      min_income: form.get('min_income_id'),
      max_income: form.get('max_income_id'),
    };
  }

  // アニメーション関連のメソッド
  updateJobCount(element, number) {
    let upto = 0;
    const jump = Math.floor(number / 100) + 1;

    const counts = setInterval(() => {
      upto = Math.min(upto + jump, number);
      element.textContent = upto;

      if (upto === number) {
        clearInterval(counts);
      }
    }, 20);
  }

  _getFormDataSearchCondition(form, formData) {
    const occupations = this.getOccupationIds(form) || [];
    const prefectures = this.getPrefectureIds(form) || [];
    const annualIncome = this.getAnnualIncome(form) || [];
    occupations.forEach(occupation => formData.append('job_types', occupation));
    prefectures.forEach(prefecture => formData.append('prefectures', prefecture));
    if (annualIncome.min_income != '') {
      formData.append('wage_min', annualIncome.min_income);
    }
    if (annualIncome.max_income != '') {
      formData.append('wage_max', annualIncome.max_income);
    }
  }
}
